export const V1_RECEIVE_AIRPORTS = 'V1_RECEIVE_AIRPORTS'

export default data => {
  return {
    type: V1_RECEIVE_AIRPORTS,
    data,
  }
}
